module.exports = __webpack_public_path__ + "static/media/FJ.f6b68f51.svg";